import { RedoDocumentationSchema } from "@redotech/redo-model/redo-documentation";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getRedoDocumentationById = {
  name: "getRedoDocumentationById" as const,
  input: z.object({ id: zExt.objectId() }),
  output: RedoDocumentationSchema.nullable(),
};
